import { TranslationService } from "@/core/services/TranslationService";
export function lookupTableHeaders() {
  return [
    {
      name: TranslationService.translate("pages.lookup.lookupName"),
      key: "lookupName",
      sortable: false,
    },
    {
      name: TranslationService.translate("common.startDate"),
      key: "startDate",
      sortable: true,
    },
    {
      name: TranslationService.translate("common.endDate"),
      key: "endDate",
      sortable: true,
    },
    {
      name: TranslationService.translate("common.createdBy"),
      key: "createdBy",
    },
    {
      name: TranslationService.translate("common.status"),
      key: "status",
    },
    {
      name: TranslationService.translate("common.actions"),
      key: "actions",
      attrs: {
        class: "vz-dataTable-center",
      },
    },
    {
      name: "",
      key: "clone",
      attrs: {
        class: "vz-dataTable-center",
      },
    },
  ];
}

export function lookupTableFilters() {
  return [
    {
      key: "lookupIds",
      label: TranslationService.translate("pages.lookup.title"),
      type: "lookup",
      attrs: {
        mode: "tags",
      },
      url: "static-data/filter/LOOKUP_NAME",
      textKey: "text",
      valueKey: "value",
    },
    {
      key: "status",
      label: TranslationService.translate("common.status"),
      type: "select",
      options: [
        { label: TranslationService.translate("common.all"), value: "" },
        {
          label: TranslationService.translate("common.active"),
          value: "ACTIVE",
        },
        {
          label: TranslationService.translate("common.inactive"),
          value: "INACTIVE",
        },
      ],
    },
    {
      key: "startDate",
      label: TranslationService.translate("common.dateRange"),
      type: "datetimerange",
    },
  ];
}

export function lookupTableBulkDelete() {
  return {
    showDelete: true,
    key: "webId",
    entity: "lookups",
    entityLabel: TranslationService.translate("pages.lookup.title"),
  };
}

export function lookupDataModelTableHeaders() {
  return [
    {
      name: TranslationService.translate("pages.lookup.code"),
      key: "code",
    },
    {
      name: TranslationService.translate("common.text"),
      key: "text",
      sortable: true,
    },
    {
      name: TranslationService.translate("common.startDate"),
      key: "startDate",
      sortable: true,
    },
    {
      name: TranslationService.translate("common.endDate"),
      key: "endDate",
      sortable: true,
    },
    {
      name: TranslationService.translate("common.sort"),
      key: "sorting",
    },
    {
      name: TranslationService.translate("common.description"),
      key: "description",
    },
    {
      name: TranslationService.translate("common.status"),
      key: "status",
    },
    {
      name: TranslationService.translate("common.actions"),
      key: "actions",
      attrs: {
        class: "vz-dataTable-center",
      },
    },
  ];
}

export function lookupLangTableHeaders() {
  return [
    {
      name: TranslationService.translate("pages.lookup.baseText"),
      key: "baseText",
    },
    {
      name: TranslationService.translate("pages.lookup.language"),
      key: "lang",
      sortable: true,
    },
    {
      name: TranslationService.translate("pages.lookup.text"),
      key: "text",
    },
    {
      name: TranslationService.translate("common.createdDate"),
      key: "createdDate",
    },
    {
      name: TranslationService.translate("common.updatedDate"),
      key: "updateDate",
    },
    {
      name: TranslationService.translate("common.actions"),
      key: "actions",
      attrs: {
        class: "vz-dataTable-center",
      },
    },
  ];
}

export function lookupLangTableFilters() {
  return [];
}

export function lookupLangTableBulkDelete() {
  return {
    showDelete: true,
    key: "webId",
    entity: "lookupsLang",
    entityLabel: TranslationService.translate("lookup.baseText"),
  };
}

export function lookupDataModelTableFilters() {
  return [
    {
      key: "userIds",
      label: TranslationService.translate("common.createdBy"),
      type: "lookup",
      attrs: {
        mode: "tags",
      },
      url: "security/filter/USERS",
      textKey: "text",
      valueKey: "value",
    },
    {
      key: "status",
      label: TranslationService.translate("common.status"),
      type: "select",
      options: [
        { label: TranslationService.translate("common.all"), value: "" },
        {
          label: TranslationService.translate("common.active"),
          value: "ACTIVE",
        },
        {
          label: TranslationService.translate("common.inactive"),
          value: "INACTIVE",
        },
      ],
    },
    {
      key: "startDate",
      label: TranslationService.translate("common.dateRange"),
      type: "datetimerange",
    },
  ];
}

export function lookupDataModelTableBulkDelete() {
  return {
    showDelete: true,
    key: "webId",
    entity: "lookupsData",
    entityLabel: TranslationService.translate("pages.lookup.lookupData"),
  };
}
